import {Component, OnInit} from "@angular/core";

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss'],
  standalone: false
})
export class UserViewComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: '/home'},
    { label: 'Home', path: 'home'},
    { label: 'View User'}
  ];

  showMessages = false;
  messages: any[] = [];

  profileName = 'View New Employee';
  savedUsername: string = '';
  savedPassword: string = '';
  savedFirstName: string = '';
  savedLastName: string = '';
  savedPhoneNumber: string = '';
  savedEmail:string = '';
  savedEIN: string = '';
  savedCompanyName: string = '';

  ngOnInit() {

  }
}
